var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagsTags = function SvgTagsTags(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.783 4 6.62 12.164c-.4.4-.619.93-.619 1.494 0 .565.22 1.097.62 1.496l4.226 4.227c.399.399.932.619 1.496.619.565 0 1.096-.22 1.494-.62L22 11.218V4h-7.217Zm-5.42.293L1.586 12.07c-.378.378-.586.88-.586 1.414 0 .535.208 1.036.586 1.414l5.363 5.366 1.414-1.414L3 13.484l7.777-7.779-1.414-1.412ZM15.611 6H20v4.389l-7.578 7.578h-.162L8.033 13.74v-.162L15.611 6ZM17 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
  })));
};
export default SvgTagsTags;